__turbopack_context__.v({
  "AccountItem": "sidebar-account-accordion-module__M5E2Tq__AccountItem",
  "Active": "sidebar-account-accordion-module__M5E2Tq__Active",
  "ButtonContainer": "sidebar-account-accordion-module__M5E2Tq__ButtonContainer",
  "Content": "sidebar-account-accordion-module__M5E2Tq__Content",
  "Header": "sidebar-account-accordion-module__M5E2Tq__Header",
  "Removed": "sidebar-account-accordion-module__M5E2Tq__Removed",
  "Sublist": "sidebar-account-accordion-module__M5E2Tq__Sublist",
  "Trigger": "sidebar-account-accordion-module__M5E2Tq__Trigger",
  "Visible": "sidebar-account-accordion-module__M5E2Tq__Visible",
  "fadeIn": "sidebar-account-accordion-module__M5E2Tq__fadeIn",
  "fadeOut": "sidebar-account-accordion-module__M5E2Tq__fadeOut",
});
